/**
 * 이슈 도메인 — UI 표시용 라벨/순서 (표시 전용).
 *
 * 정본(SSOT)은 @hcltech/shared/issue/domains — 백엔드 intake/enrich 가 코드 앵커까지 포함해 사용.
 * 프런트는 shared 가 git 의존성(main 핀)이라 표시에 필요한 라벨·순서만 로컬 미러로 둔다.
 * 라벨/도메인 추가 시 shared 와 동기화할 것. (백엔드가 domain·subdomain id 를 내려줌)
 */

export const DOMAIN_ORDER: string[] = [
  'deal', 'sourcing', 'catalog', 'pricing', 'inventory',
  'partner', 'agent', 'account', 'dashboard', 'issueloop',
];

export const DOMAIN_LABEL: Record<string, string> = {
  deal: '딜', sourcing: '소싱', catalog: '카탈로그', pricing: '가격/견적', inventory: '재고',
  partner: '거래처', agent: 'AI 에이전트/봇', account: '계정/설정/권한',
  dashboard: '대시보드', issueloop: '이슈루프',
};

export const SUB_LABEL: Record<string, Record<string, string>> = {
  deal:     { info: '정보', items: '품목', quote: '견적', server: '서버구성', sourcing: '소싱' },
  sourcing: { need: '니즈', rfq: 'RFQ', supply: '공급검색' },
  catalog:  { search: '전체검색', table: '테이블', pending: '임시등록' },
  pricing:  { sale: '판매', rental: '임대', fx: '환율' },
  partner:  { supplier: '공급사', customer: '고객사', contact: '담당자' },
  agent:    { slackbot: '슬랙봇', tools: '도구', chat: '대화' },
};

/** 도메인 id → 라벨. 없으면 '미분류'. */
export function domainLabel(id?: string | null): string {
  return id ? (DOMAIN_LABEL[id] ?? id) : '미분류';
}
/** 하위 id → 라벨. 없으면 빈 문자열. */
export function subLabel(domain?: string | null, sub?: string | null): string {
  if (!domain || !sub) return '';
  return SUB_LABEL[domain]?.[sub] ?? sub;
}
/** 스윔레인 정렬 — DOMAIN_ORDER 순, 목록에 없는 건 뒤로, 미분류 맨 뒤. */
export function domainSortKey(id?: string | null): number {
  if (!id) return 999;
  const i = DOMAIN_ORDER.indexOf(id);
  return i < 0 ? 998 : i;
}
